   
export default {
    init() {

    /*Luci di venezia*/
      var color = 'ice';


      var setVeniceColor = color => {
        $('.db-venice-color').hide()
        $(`.db-venice-color.${color}`).show()
      }

      setVeniceColor(color);

      $('#venice-color-select').change(ev => {
        color = ev.target.value
        setVeniceColor(color);
      })

      $('.db-venice-color').click(function(){
         $('.db-venice-selecting-color').hide();
         $('.db-venice-selecting-patterns-types').show();

        var ar= $(this).attr('class').split(' ')
        $('.db-venice-selecting-patterns-types .label[class*="db-no-color-"]').hide();
        $(`.db-no-color-${ar[ar.length-2]}`).show();
        $('.db-name-pattern').text(ar[ar.length-1]);

        setVeniceColor(ar[ar.length-1]);
      })


      
       $('.db-venice-select-color').click(() => {
         $('.db-venice-selecting-patterns-types').hide();
         $('.db-venice-selecting-color').show();


        setVeniceColor(color);
      });

   //slideshow gallery product

    var slideCount = null;
        
    $('.gallery-product').on('init', function(event, slick){
      slideCount = slick.slideCount;
      setSlideCount();
      setCurrentSlideNumber(slick.currentSlide);
    });

    $('.gallery-product').on('beforeChange', function(event, slick, currentSlide, nextSlide){
      setCurrentSlideNumber(nextSlide);
    });

    function setSlideCount() {
      $('.total').text(slideCount);
    }

    function setCurrentSlideNumber(currentSlide) {
      $('.current').text(currentSlide + 1);
    }
    

    // On Click
    var list = jQuery( '#modular-blocks img[src*="uploads"]' ).toArray();

    $('#modular-blocks img').click( function() {
      var src = $(this).attr('src');
      var index = null;
      // list.find($(this)).getIndex();
      // list[2] == $(this)
      list.forEach(function(imgCompare,i){
        if ($(imgCompare).attr('src') === src){
          index = i
        }
      })
      $('.modal-gallery').removeClass('modal-gallery-close');

      $('.gallery-product').slick('slickGoTo',index);
    });


    // get image from page

    function getProductImages() {
         
        var container = $('.gallery-product'),
            listLength = list.length,
            slideEl = '',
            i = 1;

        for ( i = 0; i < listLength; i++ ) {
          var el =  list[i].outerHTML;
          slideEl += '<div class="slide-gallery">'+ el +'</div>';
          container.html( slideEl );
        }
    }

    getProductImages();

    $('.gallery-product').slick({
        nextArrow: $('.next-photo'),
        prevArrow: $('.prev-photo'),
        infinite: true,
        speed: 300,
        slidesToShow: 1,
        draggable:true,
    });

    },
    finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    },

};








// WEBPACK FOOTER //
// ./scripts/routes/product.js